import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { api, setUnitId } from "@/lib/api";
import { setTenantSlug } from "@/lib/tenant";
import { useAuth } from "@/context/AuthContext";
import { EmptyState, Loading } from "@/components/kit";

export default function DemoEntry() {
  const { user, loading, logout, setUser } = useAuth();
  const qc = useQueryClient();
  const nav = useNavigate();
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (loading) return;
    (async () => {
      if (user && !user.readonly) await logout();
      try {
        const r = await api("/public/demo-session", { method: "POST" });
        setTenantSlug(r.slug);
        setUnitId(null);
        qc.resetQueries();
        setUser(r.user);
        nav("/", { replace: true });
      } catch (e) {
        setErr(e.message);
      }
    })();
  }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!err) return <Loading />;
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <EmptyState title="Demonstração indisponível" text={err} testid="demo-unavailable" action={<Link to="/cadastro" className="btn btn-primary" data-testid="demo-unavailable-signup">Criar minha conta</Link>} />
    </div>
  );
}
